import { registerLocaleData } from '@angular/common';

/**
 * Dynamically loads the locale data for the given locale ID.
 */
export function initLocale(localeId: string): Promise<void> {
    if (!localeId) {
        return;
    }

    function handleLoadError(error: any): void {
        console.error('Unable to load locale data for ' + localeId, error);
    }

    if (localeId.startsWith('mt')) {
        return import('@angular/common/locales/mt').then(registerModule).catch(handleLoadError);
    }

    if (localeId.startsWith('es')) {
        return import('@angular/common/locales/es').then(registerModule).catch(handleLoadError);
    }

    if (localeId === 'en-GB') {
        return import('@angular/common/locales/en-GB').then(registerModule).catch(handleLoadError);
    }

    if (localeId === 'en-AU') {
        return import('@angular/common/locales/en-AU').then(registerModule).catch(handleLoadError);
    }

    if (localeId === 'en-IE') {
        return import('@angular/common/locales/en-IE').then(registerModule).catch(handleLoadError);
    }

    if (localeId === 'en-NZ') {
        return import('@angular/common/locales/en-NZ').then(registerModule).catch(handleLoadError);
    }

    if (localeId === 'en-US') {
        return import('@angular/common/locales/en').then(registerModule).catch(handleLoadError);
    }

    if (localeId === 'pt-PT') {
        return import('@angular/common/locales/pt-PT').then(registerModule).catch(handleLoadError);
    }

    console.error(`Unsupported locale: ${localeId}`);
}

function registerModule(module: any): void {
    registerLocaleData(module.default);
}

export function normalizeLocaleId(id: string): string {
    if (!id) {
        return 'en-GB';
    }

    const parts = id.split('-');

    if (parts.length > 1) {
        parts[1] = parts[1].toUpperCase();
    }

    return parts.join('-');
}
